/* @flow */
import moment from 'moment';
import formatDate from 'date-fns/format';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';
import isToday from 'date-fns/is_today';

// Only dates before current date are valid
export const validateDateSince = (currentDateTime: moment): boolean => {
  const dateNow = new Date();
  return currentDateTime.valueOf() < dateNow.valueOf();
};

// Only dates before the current date and after dateSince are valid
export const validateDateUntil = (currentDateTime: moment, dateSince: moment): boolean => {
  const dateNow = new Date();
  return (
    dateNow.valueOf() > currentDateTime.valueOf() &&
    currentDateTime.valueOf() > dateSince
  );
};

// Given a number of days back, determine and return the appropriate date range
export const computeDateRangeDaySelection = (daysBack: number): Object => {
  const dateSince = new Date();
  dateSince.setDate(dateSince.getDate() - daysBack);
  return {
    from: dateSince.getTime(),
    to: new Date().getTime(),
  };
};

export const calculateDayRange = (from: number, to: number): string => {
  let dateRange;

  if (isToday(to)) {
    dateRange = `Past ${distanceInWordsStrict(from, to, { unit: 'd' })}`;
  } else {
    const dateSince = formatDate(from, 'MM-DD-YY');
    const dateUntil = formatDate(to, 'MM-DD-YY');
    dateRange = `${dateSince} to ${dateUntil}`;
  }

  return dateRange;
};



// WEBPACK FOOTER //
// ./web_modules/trustar/utils/dashboard.js